import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'
const resolveBaseURL = () => {
 
  if (typeof window === 'undefined') return 'https://test-app.yinxiongwenhua.com'

  const hostname = window.location.hostname || ''
  if (hostname === 'test-admin.yinxiongwenhua.com') return 'https://test-app.yinxiongwenhua.com'
  if (hostname === 'admin.yinxiongwenhua.com') return 'https://app.yinxiongwenhua.com'

   return 'https://test-app.yinxiongwenhua.com'
}

const baseURL = resolveBaseURL()
let token = localStorage.getItem('token') || ''

const http = axios.create({
  baseURL,
  timeout: 15000,
  withCredentials: false
})

http.interceptors.request.use(
  config => {
    if (token) config.headers.Authorization = 'Bearer ' + token
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    if (!config.headers.Accept && !config.headers.accept) {
      config.headers.Accept = 'application/json, text/plain, */*'
    }

    const method = String(config.method || 'get').toLowerCase()
    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData
    const hasContentType = Boolean(config.headers['Content-Type'] || config.headers['content-type'])
    if (!isFormData && !hasContentType && ['post', 'put', 'patch', 'delete'].includes(method)) {
      config.headers['Content-Type'] = 'application/json; charset=utf-8'
    }
    return config
  },
  error => Promise.reject(error)
)

http.interceptors.response.use(
  response => {
    const payload = response.data
    const contentType = String(response.headers?.['content-type'] || '')
    if (
      contentType.includes('text/html') ||
      (typeof payload === 'string' && /^\s*</.test(payload))
    ) {
      ElMessage.error('接口返回 HTML，可能是接口地址/代理配置错误或登录失效')
      return Promise.reject(new Error('Unexpected HTML response'))
    }
    if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'code')) {
      if (payload.code === 0 || payload.code === 200) return payload.data ?? payload
      if (payload.code === 401) {
        setToken('')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('permission')
        router.replace('/login')
        ElMessage.error('未登录')
        return Promise.reject(payload)
      }
      if (!response.config?.silentError) ElMessage.error(payload.message || '请求失败')
      return Promise.reject(payload)
    }
    return payload
  },
  error => {
 
    const message =
      error.response?.data?.message ||
      error.response?.statusText ||
      error.message ||
      '网络错误'
    if (!error.config?.silentError) ElMessage.error(message)
    return Promise.reject(error)
  }
)

const setToken = t => {
  token = t || ''
  if (t) localStorage.setItem('token', t)
  else localStorage.removeItem('token')
}

const get = (url, params, config = {}) => http.get(url, { params, ...config })
const post = (url, data, config = {}) => http.post(url, data, config)
const put = (url, data, config = {}) => http.put(url, data, config)
const patch = (url, data, config = {}) => http.patch(url, data, config)
const del = (url, config = {}) => http.delete(url, config)

const upload = (url, file, extra = {}, config = {}) => {
  const form = new FormData()
  if (Array.isArray(file)) file.forEach(f => form.append('files[]', f))
  else form.append('file', file)
  Object.entries(extra || {}).forEach(([k, v]) => form.append(k, v))
  return http.post(url, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config
  })
}

const useHttp = () => ({
  http,
  get,
  post,
  put,
  patch,
  del,
  upload,
  setToken
})

export { http, useHttp, setToken, get, post, put, patch, del, upload }
